import { RayAnnotationType } from 'Constants/EAnnotationType';

export class TriangleModelInfo {
    constructor() {
        this.AnnotationType = RayAnnotationType.TRIANGLE_AnnotationType;
        // Set all defaults
        this.ObjectBrushHex = "#FF0066CC";
        this.LineWidth = 2;
        this.Opacity = 100;
    }
}
